import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { CommonDataService } from 'src/app/shared/services/common-data.service';
import { CallCenterService } from '../../call-center-service';

@Component({
  selector: 'app-layout-header',
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.scss']
})
export class LayoutHeaderComponent implements OnInit {

  @Input() photoUrlRecieve: string;

  userName: string;
  greetings: string;
  shortName: string;
  isImpersonating: boolean = false;
  employerAgentList: any = [];
  employerList: any = [];
  selectedAgentId: any;
  selectedEmployerId: any;

  constructor(
    private router: Router, private userService: UserService,
    private loaderService: WindowLoaderService,
    public commonDataService: CommonDataService,
    public callCenterService: CallCenterService
  ) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.userName = userDetails.name;
        const matches = this.userName.match(/\b(\w)/g);
        this.shortName = matches.slice(0, 2).join('');
        this.isImpersonating = userDetails.isImpersonating;
      },
      (error) => { console.error(error); }
    );

    const today = new Date();
    const curHr = today.getHours();

    if (curHr < 12) {
      this.greetings = 'Good Morning';
    } else if (curHr < 18) {
      this.greetings = 'Good Afternoon';
    } else {
      this.greetings = 'Good Evening';
    }
    this.getAllEmployerAgent();
  }

  private getAllEmployerAgent() {
    this.loaderService.show();
    this.userService.getUsersByRoleCategory("Agent")
      .subscribe(
        (employerPage) => {
          if (employerPage && employerPage.length) {
            this.employerAgentList = employerPage.filter(x => x.healthOrganizationId !== null);
            this.callCenterService.setSelectedAgent(this.employerAgentList[0]);
            this.selectedAgentId = this.employerAgentList[0].id;
            this.filterEmployerBasedOnAgent(this.employerAgentList[0]);            
          }
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  public filterEmployerBasedOnAgent(agent: any) { 
    this.selectedEmployerId = null;
    this.callCenterService.setSelectedAgent(agent);
    this.loaderService.show();
    this.userService.filterEmployerBasedOnAgent(agent.healthOrganizationId, 'EMP')
      .subscribe(
        (response) => {
          this.employerList = response;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  public getMembersBasedOnEmployer(employer: any) {
    this.callCenterService.setSelectedEmployer(employer);  
  }

  signOut() {
    window.location.href = `/Session/SignOut`;
  }

  settingPage() {
    this.router.navigate(['physician/profile/signIn']);
  }


  stopImpersonating() {
    this.userService.cancelImpersonate();
  }
}
